<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/necessidadeespecial"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaonecessidadeespecial }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadornecessidadeespecial"
      :novo="novaNecessidadeEspecial"
      :editar="editarNecessidadeEspecial"
      :excluir="excluirNecessidadeEspecial"
      :cancelar="cancelarNecessidadeEspecial"
      :submit="onSubmit"
      class="mb-3">
      <!-- *******  -->
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaNecessidadeEspecial">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
    <!-- *******  -->
      <v-card>
        <v-card-text >
          <Input type="text" label="Código da Necessidade Especial" v-model="form.identificadornecessidadeespecial" disabled />
          <Input type="text" label="Descrição da Necessidade Especial" ref="focusCampo" v-model="form.descricaonecessidadeespecial" :disabled="acao == ''" :v="$v.form.descricaonecessidadeespecial" />
          <Validator label="Necessidade Especial autorizada para AEE?" :disabled="acao == ''" :v="$v.form.indicaautorizacaoaee">
            <Radio v-model="form.indicaautorizacaoaee" :disabled="acao == ''" val="N" label="Não"/>
            <Radio v-model="form.indicaautorizacaoaee" :disabled="acao == ''"  val="S" label="Sim"/>
          </Validator>
        </v-card-text>
      </v-card>

    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>

import api from '@/api';
import Input from '@/components/Input';
import Radio from '@/components/Radio';
import Validator from '@/components/Valitador';
import FormBasico from '@/components/FormBasico';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required, maxLength, minLength, alpha, integer,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadornecessidadeespecial: '',
  descricaonecessidadeespecial: '',
  indicaautorizacaoaee: '',
});

export default {
  name: 'NecessidadeEspecial',
  components: {
    Input,
    //InputMask,
    Validator,
    Radio,
    FormBasico,
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaonecessidadeespecial',
      buscaOptions: [
        { value: 'identificadornecessidadeespecial', text: 'Código' },
        { value: 'descricaonecessidadeespecial', text: 'Descrição da Necessidade Especial' },
      ],
    };
  },
  validations: {
    form: {
      descricaonecessidadeespecial: {
        required, alphaSpace, maxLength: maxLength(30), minLength: minLength(4),
      },
      indicaautorizacaoaee:{
        required,

      },
    },
  },
  methods: {
    tabelaNecessidadeEspecial() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Necessidade Especial / Listar',
          rota_api: 'gerencial/necessidadeespecial/tabela',
          headers: [{ text: 'Identificador', value: 'identificadornecessidadeespecial', sortable: false },
                    { text: 'Descrição', value: 'descricaonecessidadeespecial', sortable: false },
                    { text: 'Necessidade Especial autorizada para AEE?', value: 'indicaautorizacaoaee', sortable: false }],
        },
      });
    },
    novaNecessidadeEspecial() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarNecessidadeEspecial() {
      if (this.form.identificadornecessidadeespecial !== '') {
        this.acao = 'editar';
      }
    },
    cancelarNecessidadeEspecial() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirNecessidadeEspecial() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta necessidade especial?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/necessidadeespecial/${this.form.identificadornecessidadeespecial}`);
          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },

/*
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try{
        const funcao = (this.acao === 'novo') ? 'post' : 'put';

        const { data } = await AARepository[`${funcao}NecessidadeEspecial`](this.form);

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.acao = '';
      }
      catch (error){
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      this.$v.$reset();
    },
  */
  onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }
      api({
        method: (this.acao === 'novo') ? 'post' : 'put',
        url: `gerencial/necessidadeespecial${(this.acao === 'novo') ? '' : `/${this.form.identificadornecessidadeespecial}`}`,
        data: this.form,
      }).then((response) => {
        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
      }).catch((error) => {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
    },
  encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
  },
};
</script>

<style>

</style>
